(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('EnvResultDetSearch', EnvResultDetSearch);

    EnvResultDetSearch.$inject = ['$resource'];

    function EnvResultDetSearch($resource) {
        var resourceUrl =  'api/_search/env-result-dets/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
